import { render, staticRenderFns } from "./ModalPossibleMatches.vue?vue&type=template&id=e76e0576&"
import script from "./ModalPossibleMatches.vue?vue&type=script&lang=js&"
export * from "./ModalPossibleMatches.vue?vue&type=script&lang=js&"
import style0 from "./ModalPossibleMatches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports